import React from "react";
import "../component/Touch.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
// import SendIcon from "@mui/icons-material/Send";
import TelegramIcon from "@mui/icons-material/Telegram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";

function Touch() {
  return (
    <div className="Get-in-touch">
      <div className="title">
        <p>Get in Touch</p>
      </div>
      <div className="msg-add">
        <div className="address-details">
          <div className="home-add">
            <p className="location">
              <span className="material-icon">
                <LocationOnIcon />
              </span>
              <span>Location</span>
            </p>
            <p className="add-details">Joynagar,743337,Kolkata,India </p>
          </div>
          <div className="contact-details">
            <li>
              <a href="mailto: praymondal@gmail.com">
                <p className="material-icon">
                  <EmailIcon />
                </p>
                <p>
                  <b>&nbsp;Email&nbsp;:&nbsp;</b>
                </p>
                <p className="name_address">praymondal@gmail.com</p>
              </a>
            </li>
            <li>
              <a href="tel:+917365866197">
                <p className="material-icon">
                  <CallIcon />
                </p>
                <p>
                  <b>&nbsp;Phone&nbsp;:&nbsp;</b>
                </p>
                <p className="name_address">7365866197</p>
              </a>
            </li>
          </div>
          <div className="social-links">
            <p>FOLLOW&nbsp;ME</p>
            <ul>
              <li>
                <a href="https://github.com/PIJUSH364">
                  {" "}
                  <GitHubIcon />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/pijush-ray-mondal-621980192/">
                  <LinkedInIcon />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/pijushrm_24/">
                  <InstagramIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <form className="massage-section">
          <div className="sub-title-msg">
            <p>SEND US A NOTE</p>
          </div>
          <div className="name-email">
            <input type="text" placeholder="Your Name" required="true" />
            <input type="email" placeholder="Email Address" required="true" />
          </div>
          <div className="message-fill">
            <input type="text" placeholder="Subject" />
            <textarea
              name=""
              id=""
              cols="20"
              rows="8"
              placeholder="Tell us more about your needs..."
              required="true"
            ></textarea>
          </div>
          <div className="sendMg">
            <button type="submit">
              <span className="type--write--animation">
                {" "}
                Send Massage&nbsp;
              </span>
              <span className="ani">
                <TelegramIcon />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Touch;
